import requestor from "../../requestor";

export default class HelpApi {
  sections = {
    all: () => requestor.get("/faq-chapter/all"),
    create: (title) =>
      requestor.post("/faq-chapter/create", {
        title: title,
      }),
    save: (id, title) =>
      requestor.put("/faq-chapter/save", {
        FaqChapter: {
          id: id,
          title: title,
        },
      }),
    replace: (id, next_id) =>
      requestor.get("/faq-chapter/replace", {
        id: id,
        next_id: next_id,
      }),
    remove: (id) =>
      requestor.get("/faq-chapter/delete", {
        id: id,
      }),
  };

  index = {
    all: (enabled, main, id = null) =>
      requestor.get("/faq-article/all", {
        filter: {
          chapter_id: id === "null" ? null : id,
          enabled: !enabled ? null : true,
          main: !main ? null : true,
        },
      }),
    delete: (id) =>
      requestor.get("/faq-article/delete", {
        id,
      }),
    changeIsActive: (id) =>
      requestor.get("/faq-article/toggle-enable", {
        id,
      }),
    changeIsMainPage: (id) =>
      requestor.get("/faq-article/toggle-main", {
        id,
      }),
    to_prev: (id) =>
      requestor.get("/faq-article/to-prev", {
        id,
      }),
    to_next: (id) =>
      requestor.get("/faq-article/to-next", {
        id,
      }),
  };

  article = {
    create: (title, alias, chapter_id, text, enabled, main, is_useful, image) => {
      return requestor.post("/faq-article/create", {
        title,
        alias,
        chapter_id,
        text,
        enabled,
        main,
        is_useful,
        image,
      });
    },
    save(title, alias, chapter_id, text, enabled, main, is_useful, image, id) {
      return requestor.post("/faq-article/save", {
        FaqArticle: {
          title,
          alias,
          chapter_id,
          text,
          enabled,
          main,
          is_useful,
          image,
          id,
        },
      });
    },
    one: (id) =>
      requestor.get("/faq-article/one", {
        id,
      }),

    faq: {
      all: (article_id) =>
        requestor.get("/faq-question/all", {
          article_id,
        }),
      create: (article_id, title, text) =>
        requestor.get("/faq-question/create", {
          article_id,
          title,
          text,
        }),
      save: (id, title, text) =>
        requestor.get("/faq-question/save", {
          FaqQuestion: {
            id,
            title,
            text,
          },
        }),
      delete: (id) =>
        requestor.get("/faq-question/delete", {
          id,
        }),
    },
  };
}
